var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStore = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38462 12.5769V18.8077C2.38462 18.9913 2.45755 19.1674 2.58739 19.2972C2.71722 19.4271 2.89331 19.5 3.07692 19.5H16.9231C17.1067 19.5 17.2828 19.4271 17.4126 19.2972C17.5424 19.1674 17.6154 18.9913 17.6154 18.8077V12.5769M11.3846 12.5769V19.5M2.38462 14.6538H11.3846M1 6.34615L3.07692 1.5H16.9231L19 6.34615H1ZM1 6.34615V7.73077C1 8.46522 1.29176 9.16958 1.81109 9.68891C2.33042 10.2082 3.03479 10.5 3.76923 10.5H4.15692C4.89137 10.5 5.59573 10.2082 6.11506 9.68891C6.6344 9.16958 6.92615 8.46522 6.92615 7.73077V6.34615",
    stroke: "#6E84A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1154 6.34619V7.73081M13.1154 7.73081C13.1154 8.46525 12.8237 9.16962 12.3043 9.68895C11.785 10.2083 11.0806 10.5 10.3462 10.5H9.65387C8.91943 10.5 8.21506 10.2083 7.69573 9.68895C7.1764 9.16962 6.88464 8.46525 6.88464 7.73081V6.34619M13.1154 7.73081C13.1154 8.46525 13.4072 9.16962 13.9265 9.68895C14.4458 10.2083 15.1502 10.5 15.8846 10.5H16.2308C16.9652 10.5 17.6696 10.2083 18.1889 9.68895C18.7083 9.16962 19 8.46525 19 7.73081V6.34619",
    stroke: "#6E84A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/store.81a81246.svg";
export { ForwardRef as ReactComponent };